module.exports = __webpack_public_path__ + "media/B47.12577bee.mp3";